import { Button, Col, Input, Row, Form, Radio, notification } from "antd";
import { EMAIL_PATTERN, PASSWORD_RULES, PHONE_PATTERN } from "../../config/constant";
import "./style/registrationForm.scss";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { registerUserApi } from "../../config/Api";

export const Registration = () => {
    const [form] = Form.useForm()
    const navigate = useNavigate();
    // while the account is being created (the verification email is sent first, so it takes a few seconds)
    const [registering, setRegistering] = useState(false);

    const onFinish = (values) => {
        const data = {
            name: values.name,
            email: values.email,
            password: values.password,
            phone: values.phoneNo,
            type_of_account: values.profession,
        };

        setRegistering(true);
        registerUserApi(data)
            .then((res) => {
                if (res.status === 200 || res.status === 201) {
                    notification.success({
                        message: "Registration Successful",
                        description: res.data.message,
                        duration: 10,
                    });
                    navigate("/");
                } else {
                    notification.error({
                        message: "Registration Failed",
                        description: res.data.message || "Something went wrong.",
                    });
                }
            })
            .catch((err) => {
                // show the first validation error (e.g. email already taken) when there is one
                const errors = err.response?.data?.errors;
                const errMsg = (errors && Object.values(errors)[0]?.[0])
                    || err.response?.data?.message
                    || "Registration failed. Please try again.";
                notification.error({
                    message: "Registration Failed",
                    description: errMsg,
                });
            })
            .finally(() => setRegistering(false));
    };

    const resetData = () => {
        form.resetFields()
    };

    return (
        <div className="registerForm">
            <Form
                name="registerForm"
                form={form}
                onFinish={onFinish}
            >
                <Row justify="center">
                    <Col xs={24} md={16} xl={13} xxl={{ span: 12 }}>
                        <div id="registerFormContent" className="p-4 rounded">
                            <h4 className="text-center login-title">Registration</h4>
                            <Row
                                gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]}
                                className="text-left"
                            >
                                <Col xs={24} md={24} lg={24} xl={11} xxl={{ span: 12 }}>
                                    <label className="form-input-label">
                                        Name
                                        <span className="asterik"> *</span>
                                    </label>
                                    <Form.Item
                                        name="name"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please insert Name!",
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Enter Name" className="mt-2 p-2" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={24} lg={24} xl={11} xxl={{ span: 12 }}>
                                    <label className="form-input-label">
                                        Phone Number
                                        <span className="asterik"> *</span>
                                    </label>
                                    <Form.Item
                                        name="phoneNo"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please insert Phone Number!",
                                            },
                                            {
                                                pattern: PHONE_PATTERN,
                                                message: "Please insert valid phone no!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Enter Mobile Number"
                                            className="mt-2 p-2"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={24} lg={24} xl={11} xxl={{ span: 12 }}>
                                    <label className="form-input-label">
                                        Official Email Id
                                        <span className="asterik"> *</span>
                                    </label>
                                    <Form.Item
                                        name="email"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please insert Email!",
                                            },
                                            {
                                                pattern: EMAIL_PATTERN,
                                                message: "Please insert valid data!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Enter official Email Id"
                                            className="mt-2 p-2"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={24} lg={24} xl={11} xxl={{ span: 12 }}>
                                    <label className="form-input-label text-start">
                                        Password
                                        <span className="asterik"> *</span>
                                    </label>
                                    <Form.Item
                                        name="password"
                                        rules={[
                                            { required: true, message: "Please insert Password!" },
                                            ...PASSWORD_RULES,
                                        ]}
                                    >
                                        <Input.Password
                                            placeholder="Password"
                                            className="mt-2 p-2"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={24} lg={24} xl={11} xxl={{ span: 24 }}>
                                    <label className="form-input-label">
                                        Profession Type
                                        <span className="asterik"> *</span>
                                    </label>
                                    <Form.Item
                                        name="profession"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Select Profession Type!",
                                            },
                                        ]}
                                    >
                                        <Radio.Group>
                                            <Radio value="Nutritionist (Ayurveda)">Nutritionist (Ayurveda)</Radio>
                                            <Radio value="Nutritionist General">Nutritionist General</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>
                                <Col span={24} className="text-center">
                                    <Button htmlType="submit" loading={registering} className="submit-button b-0 rounded">
                                        {registering ? 'REGISTERING' : 'REGISTER'}
                                    </Button>
                                    <Button onClick={() => resetData()} disabled={registering} className="reset-button ms-4 b-0 rounded">
                                        RESET
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};
